<template>
    <div>
        <div class="panel animated fadeInRightBig">
            <div class="panel-heading">
                <div class="panel-title">
                    <div class="row">
                        <div class="col-md-12">
                            <span class="title">
                                {{ admin.name }}

                                <i class="fa fa-user-circle" style="float:right;margin-top:6px;font-size:21px;"></i>
                            </span>

                            <hr class="m-t-md">
                        </div>

                        <div class="col-md-4">
                            <div class="block" style="padding:5px 25px 25px 25px">
                                <span class="block m-t-sm">
                                    <b>Nome:</b> {{ admin.name }}
                                </span>

                                <span class="block m-t-sm">
                                    <b>E-mail:</b> {{ admin.email }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <router-link to="/admins" class="btn btn-info" style="float:right">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                </div>
            </div>
            <div class="panel-body">
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                admin: {
                    name: '',
                    email: '',
                    password: '',
                },
                errors: undefined
            }
        },
        computed: {},
        methods: {
            getAdmin: function(){
                let self = this;
                let id   = self.$route.params.id;
                let api  = self.$store.state.api + 'admins/' + id;

                self.$http.get(api)
                    .then((response) => {
                        self.admin = response.data.data[0];
                    })
                    .catch((error) => {
                        self.errors = error.response.data;
                        self.$message(null, self.errors, 'error');
                    });
            }
        },
        mounted: function(){
            this.getAdmin();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Admin/View.vue